import { FormType } from '../../../form-types';

export const edBeluga: FormType = {
  name: 'Erectile Dysfunction Questionnaire',

  questions: [
    {
      key: 'edBeluga_sexAssignedAtBirth',
      next: {
        condition: {
          'edBeluga_sexAssignedAtBirth.edBeluga_sexAssignedAtBirth_female': true
        },
        key: 'edBeluga_ineligible',
        els: 'generic_heightWeight2025'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'edBeluga_erectionProblem',
      next: {
        condition: {
          'edBeluga_erectionProblem.edBeluga_erectionProblem_never': true
        },
        key: 'edBeluga_ineligible',
        els: 'edBeluga_erectionTiming'
      }
    },
    'edBeluga_erectionTiming',
    {
      key: 'edBeluga_previousTreatment',
      next: {
        condition: {
          'edBeluga_previousTreatment.edBeluga_previousTreatment_yes': true
        },
        key: 'edBeluga_previousTreatment_details',
        els: 'edBeluga_bloodPressureHistory'
      }
    },
    'edBeluga_previousTreatment_details',
    {
      key: 'edBeluga_sideEffects',
      next: {
        condition: {
          'edBeluga_sideEffects.edBeluga_sideEffects_yes': true
        },
        key: 'edBeluga_sideEffects_details',
        els: 'edBeluga_lastMedicationUse'
      }
    },
    'edBeluga_sideEffects_details',
    'edBeluga_lastMedicationUse',
    {
      key: 'edBeluga_bloodPressureHistory',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_bloodPressureHistory.edBeluga_bloodPressureHistory_high':
                true
            },
            key: 'edBeluga_bloodPressure_value'
          },
          {
            condition: {
              'edBeluga_bloodPressureHistory.edBeluga_bloodPressureHistory_low':
                true
            },
            key: 'edBeluga_bloodPressure_value'
          }
        ],
        els: 'edBeluga_medications'
      }
    },
    'edBeluga_bloodPressure_value',
    {
      key: 'edBeluga_medications',
      next: {
        condition: {
          'edBeluga_medications.edBeluga_medications_none': true
        },
        key: 'edBeluga_cardiovascularRisks',
        els: 'edBeluga_ineligible'
      },
    },
    {
      key: 'edBeluga_cardiovascularRisks',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_diabetes':
                true
            },
            key: 'edBeluga_cardiovascularRisks_diabetes_details'
          },
          {
            condition: {
              'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_cholesterol':
                true
            },
            key: 'edBeluga_cardiovascularRisks_cholesterol_details'
          },
          {
            condition: {
              'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_bloodPressure':
                true
            },
            key: 'edBeluga_cardiovascularRisks_bloodPressure_details'
          }
        ],
        els: 'edBeluga_diagnoses'
      }
    },
    {
      key: 'edBeluga_cardiovascularRisks_diabetes_details',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_cholesterol':
                true
            },
            key: 'edBeluga_cardiovascularRisks_cholesterol_details'
          },
          {
            condition: {
              'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_bloodPressure':
                true
            },
            key: 'edBeluga_cardiovascularRisks_bloodPressure_details'
          }
        ],
        els: 'edBeluga_diagnoses'
      }
    },
    {
      key: 'edBeluga_cardiovascularRisks_cholesterol_details',
      next: {
        condition: {
          'edBeluga_cardiovascularRisks.edBeluga_cardiovascularRisks_bloodPressure':
            true
        },
        key: 'edBeluga_cardiovascularRisks_bloodPressure_details',
        els: 'edBeluga_diagnoses'
      }
    },

    'edBeluga_cardiovascularRisks_bloodPressure_details',

    {
      key: 'edBeluga_diagnoses',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_prostateCancer': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_enlargedProstate': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_kidney': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_liverDisease': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: { 'edBeluga_diagnoses.edBeluga_diagnoses_ms': true },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_spinalInjuries': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_neurological': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_ulcers': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_arrhythmias': true
            },
            key: 'edBeluga_diagnoses_details'
          },
          {
            condition: {
              'edBeluga_diagnoses.edBeluga_diagnoses_heartAbnormalities': true
            },
            key: 'edBeluga_diagnoses_details'
          }
        ],
        els: 'edBeluga_cardiovascularSymptoms'
      }
    },
    'edBeluga_diagnoses_details',
    {
      key: 'edBeluga_cardiovascularSymptoms',
      next: {
        condition: {
          'edBeluga_cardiovascularSymptoms.edBeluga_cardiovascularSymptoms_legCramps':
            true
        },
        key: 'edBeluga_cardiovascularSymptoms_legCramps_details',
        els: 'edBeluga_recreationalDrugs'
      }
    },
    'edBeluga_cardiovascularSymptoms_legCramps_details',
    {
      key: 'edBeluga_recreationalDrugs',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_recreationalDrugs.edBeluga_recreationalDrugs_poppers':
                true
            },
            key: 'edBeluga_recreationalDrugs_details'
          },
          {
            condition: {
              'edBeluga_recreationalDrugs.edBeluga_recreationalDrugs_amylNitrate':
                true
            },
            key: 'edBeluga_recreationalDrugs_details'
          },
          {
            condition: {
              'edBeluga_recreationalDrugs.edBeluga_recreationalDrugs_cocaine':
                true
            },
            key: 'edBeluga_recreationalDrugs_details'
          },
          {
            condition: {
              'edBeluga_recreationalDrugs.edBeluga_recreationalDrugs_cigarettes':
                true
            },
            key: 'edBeluga_recreationalDrugs_details'
          },
          {
            condition: {
              'edBeluga_recreationalDrugs.edBeluga_recreationalDrugs_other':
                true
            },
            key: 'edBeluga_recreationalDrugs_details'
          }
        ],
        els: 'edBeluga_penileSymptoms'
      }
    },
    'edBeluga_recreationalDrugs_details',
    {
      key: 'edBeluga_penileSymptoms',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_penileSymptoms.edBeluga_penileSymptoms_pain': true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_penileSymptoms.edBeluga_penileSymptoms_foreskin': true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_penileSymptoms.edBeluga_penileSymptoms_curve': true
            },
            key: 'edBeluga_peyronies_12months'
          }
        ],
        els: 'edBeluga_otherConditions'
      }
    },
    {
      key: 'edBeluga_peyronies_12months',
      next: {
        condition: {
          'edBeluga_peyronies_12months.edBeluga_peyronies_12months_yes': true
        },
        key: 'edBeluga_ineligible',
        els: 'edBeluga_otherConditions'
      }
    },

    {
      key: 'edBeluga_otherConditions',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_priapism':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_pah':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_retinitisPigmentosa':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_suddenVisionLoss':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_bloodDisorders':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_ihss':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_icd':
                true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_heartAttack':
                true
            },
            key: 'edBeluga_recentHeartAttack'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_neurologicDisease':
                true
            },
            key: 'edBeluga_recentStroke'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_clottingDisorder':
                true
            },
            key: 'edBeluga_otherConditions_details'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_stomachUlcer':
                true
            },
            key: 'edBeluga_otherConditions_details'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_pad':
                true
            },
            key: 'edBeluga_otherConditions_details'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_qtProlongation':
                true
            },
            key: 'edBeluga_otherConditions_details'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_bloodThinners':
                true
            },
            key: 'edBeluga_otherConditions_details'
          }
        ],
        els: 'edBeluga_otherInformation'
      }
    },
    {
      key: 'edBeluga_recentHeartAttack',
      next: {
        switch: [
          {
            condition: {
              'edBeluga_recentHeartAttack.edBeluga_recentHeartAttack_yes': true
            },
            key: 'edBeluga_ineligible'
          },
          {
            condition: {
              'edBeluga_otherConditions.edBeluga_otherConditions_neurologicDisease':
                true
            },
            key: 'edBeluga_recentStroke'
          }
        ],
        els: 'edBeluga_otherConditions_details'
      }
    },
    {
      key: 'edBeluga_recentStroke',
      next: {
        condition: {
          'edBeluga_recentStroke.edBeluga_recentStroke_yes': true
        },
        key: 'edBeluga_ineligible',
        els: 'edBeluga_otherConditions_details'
      }
    },
    'edBeluga_otherConditions_details',
    'edBeluga_otherInformation',
    {
      key: 'edBeluga_consent',
      next: {
        condition: {
          'edBeluga_consent.edBeluga_consent_consent': true
        },
        key: 'edBeluga_complete',
        els: 'edBeluga_didNotConsent'
      }
    },
    'edBeluga_ineligible',
    'edBeluga_didNotConsent',
    'edBeluga_complete'
  ]
};
export const edus: FormType = {
  name: 'Erectile Dysfunction',
  questions: [
    'edinterest',
    'edTakenMed',
    'currSexDur',
    'everUsedNit',
    'lastMornErect',
    'lastNormSexFunc',
    'apprxDateRecBP',
    'everBPTooHighLow',
    'recentSysBP',
    'recentDiaBP',
    'feelHealthyForSex',
    'causeSexualIssues',
    'last3MonthsRecreationalDrugs',
    'anythingElseToKnow'
  ]
};
export const ed: FormType = {
  name: 'Erectile Dysfunction',
  questions: [
    'ed1',
    'ed2',
    'ed3',
    'ed33',
    'ed4',
    'ed5',
    'ed55',
    'ed6',
    'ed66',
    'ed7',
    'ed8',
    'ed9',
    'ed10',
    'ed11',
    'ed12'
  ]
};
export const ped: FormType = {
  name: 'Promo Erectile Dysfunction',
  questions: [
    'ed1',
    'ed2',
    'ed3',
    'ed33',
    'ed4',
    'ed5',
    'ed55',
    'ed6',
    'ed66',
    'ed7',
    'pedPref'
  ]
};
